import React from 'react';
import { createSelector } from 'reselect';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import lodash from 'lodash';
import { LINE_VOLTAGES } from '../../../../appConstants';
import AppFunctionsService from '../../../../services/appFunctionsService';

interface ILineVoltageRangeDropdownProps {
    id ?: string;
    value : [number, number] | null;

    onChange ?: (value : [number, number] | null) => void;

    required ?: boolean;
    autoFocus ?: boolean;

    fullWidth ?: boolean;

    label ?: string;
    clearable ?: boolean;
}

interface ILineVoltageRangeDropdownState {
}

export default class LineVoltageRangeDropdown extends React.Component<ILineVoltageRangeDropdownProps, ILineVoltageRangeDropdownState> {
    constructor(props : ILineVoltageRangeDropdownProps) {
        super(props);

        this.state = {
        };
    }

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : [number, number] | null;
    } | null) => {
        if (this.props.onChange) this.props.onChange(value?.value ?? null);
    };

    private readonly getValue = (state : ILineVoltageRangeDropdownState, props : ILineVoltageRangeDropdownProps) => props.value;
    private readonly getRequired = (state : ILineVoltageRangeDropdownState, props : ILineVoltageRangeDropdownProps) => props.required;
    private readonly getClearable = (state : ILineVoltageRangeDropdownState, props : ILineVoltageRangeDropdownProps) => props.clearable;

    private readonly getLineVoltageRangeDropdown = createSelector([
        this.getRequired,
        this.getClearable,
    ], (required, clearable) => {
        const drop : Array<{
            label : string;
            value : [number, number] | null;
        }> = lodash.map(LINE_VOLTAGES, n => ({
            label: AppFunctionsService.getLineVoltageRangeLabel(n),
            value: n,
        }));

        if (!required && !clearable) {
            drop.unshift({
                label: 'ALL',
                value: null,
            });
        }

        return drop;
    });

    private readonly getSelectedValue = createSelector([
        this.getValue, this.getRequired, this.getClearable,
    ], (value, required, clearable) => {
        if (value) {
            const range = LINE_VOLTAGES.find(x => x === value);

            if (range) {
                return { label: AppFunctionsService.getLineVoltageRangeLabel(range), value: range };
            } else {
                return { label: AppFunctionsService.getLineVoltageRangeLabel(value), value };
            }
        }

        if (!required && !clearable) {
            return {
                label: 'ALL',
                value: null,
            };
        }

        return null;
    });

    public readonly render = () => {
        const { required, fullWidth, id, label = 'Line Voltage Range', clearable } = this.props;

        const dropdown = this.getLineVoltageRangeDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);
        return (
            <FormControl fullWidth={fullWidth} error={required && !value} required={required}>
                <Autocomplete
                    id={id}
                    options={dropdown}
                    value={value}
                    getOptionSelected={(option, val) => option.label === val.label}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required && !clearable}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth={fullWidth} label={label} />}
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
                <div className='wfill' style={{
                    minHeight: 8,
                }}>
                </div>
            </FormControl>
        );
    };
}
